import { EventEmitter, Injectable, Output } from '@angular/core';


@Injectable()
export class IdleTimer {

    @Output()
    timeoutWarning: EventEmitter<void> = new EventEmitter();

    @Output()
    timedOut: EventEmitter<void> = new EventEmitter();

    private updateExpiredTimeBound: () => void;

    private timeoutInterval: any;
    private timeoutDuration = 60;
    private updateTimer: any;

    constructor() {
        // Bind the method to the class instance
        this.updateExpiredTimeBound = this.updateExpiredTime.bind(this);
    }

    start(timeoutDuration: number = 15) {
        // stop any existing idle timer
        if (this.timeoutInterval != null) {
            this.stop();
        }

       // Log.debug('starting timer for minutes: ' + timeoutDuration)

        // set the timeout duration
        this.timeoutDuration = timeoutDuration * 60;

        // start a new idle timer
        this.startTimeoutTimer();
        this.bindWindowEvents();
        this.updateExpiredTime();
    }

    stop() {
        // clear the timeout timer
        if (this.timeoutInterval != null) {
            clearInterval(this.timeoutInterval);
            this.timeoutInterval = null;
        }

        // clear the update timer
        if (this.updateTimer != null) {
            clearTimeout(this.updateTimer);
            this.updateTimer = null;
        }

        // clean up local storage
        localStorage.removeItem('timeout');
        localStorage.removeItem('timeoutWarning');

        // unbind events
        this.unbindWindowEvents();
    }

    private startTimeoutTimer() {

        // start a new idle timer
        this.timeoutInterval = setInterval(() => {
            // get the time from local storage
            const expiredTime = +(localStorage.getItem('timeout') || '0');

            // determine the time remaining
            const timeRemaining = expiredTime - new Date().valueOf();

            // if we have < 30 seconds remaining, emit a warning and store that we have done so
            if (timeRemaining < 30000 && !localStorage.getItem('timeoutWarning')) {
                this.timeoutWarning.emit();
                localStorage.setItem('timeoutWarning', 'true');
            } else if (timeRemaining < 0) {
                // if the time is less than the current time, then we have timed out
                this.timedOut.emit();
                this.stop();
            }
        }, 1000);
    }

    private updateExpiredTime() {
        // if we moved then the timeout should be extended so we can reset the warning
        localStorage.removeItem('timeoutWarning');

        // Reset the expired time right away to avoid a 300ms gap before the timer below does it.
        const expiredTime = new Date().valueOf() + (this.timeoutDuration * 1000);
        localStorage.setItem('timeout', expiredTime.toString());

        // if we hadn't written the previous value, that's fine just clear it out
        if (this.updateTimer != null) {
            clearTimeout(this.updateTimer);
            this.updateTimer = null;
        }

        // create a new timer
        this.updateTimer = setTimeout(() => {
            const expiredTime = new Date().valueOf() + (this.timeoutDuration * 1000);
            localStorage.setItem('timeout', expiredTime.toString());
        }, 300);
    }

    private bindWindowEvents() {
        window.addEventListener('mousemove', () => this.updateExpiredTimeBound());
        window.addEventListener('scroll', () => this.updateExpiredTimeBound());
        window.addEventListener('keydown', () => this.updateExpiredTimeBound());
    }

    private unbindWindowEvents() {
        window.removeEventListener('mousemove', () => this.updateExpiredTimeBound());
        window.removeEventListener('scroll', () => this.updateExpiredTimeBound());
        window.removeEventListener('keydown', () => this.updateExpiredTimeBound());
    }

}
